import { watchFetchDepartingSoon } from './fetchDepartingSoon';

export const departingSoonSagas = [watchFetchDepartingSoon()];
